export const SHOW_SLACK_OPTIN_MODAL = 'SHOW_SLACK_OPTIN_MODAL';
export const DISMISS_SLACK_OPTIN_MODAL = 'DISMISS_SLACK_OPTIN_MODAL';
